import React from "react";
import AppRoutes from "./AppRoutes";
import {useDispatch} from "react-redux";
import { updateTheme } from "./actions/mainAction";
import { ThemeProvider } from "@material-ui/core";
import TypographyTheme from "./styles/TypographyTheme";
import "./App.css";

function App() {
  const dispatch = useDispatch();
  document.addEventListener("gesturestart", function (e) {
    e.preventDefault();
  });

  dispatch(
    updateTheme({
      darkBackground: process.env.REACT_APP_DARK_BACKGROUND,
      lightBackground: process.env.REACT_APP_LIGHT_BACKGROUND,
      darkFont: process.env.REACT_APP_DARK_FONT,
      lightFont: process.env.REACT_APP_LIGHT_FONT,
      inStockColor: process.env.REACT_APP_IN_STOCK_COLOR,
      stockColor: process.env.REACT_APP_STOCK_COLOR,
      active: process.env.REACT_APP_ACTIVE,
    })
  );

  return (
    <div className="App-Routes">
      <ThemeProvider theme={TypographyTheme}>
        <AppRoutes />
      </ThemeProvider>
    </div>
  );
}

export default App;
